// tslint:disable: max-line-length
// COMPONENTES
import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { APP_BASE_HREF, registerLocaleData } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import localePt from '@angular/common/locales/pt';
import { LOCALE_ID, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgbAccordionModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TagInputModule } from 'ngx-chips';
import { NgxCurrencyDirective } from 'ngx-currency';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { NgxMapboxGLModule } from "ngx-mapbox-gl";
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { MessageService } from 'primeng/api';
import { CarouselModule } from 'primeng/carousel';
import { ToastModule } from 'primeng/toast';
import { MatStepperModule } from '@angular/material/stepper';
import { MatFormFieldModule } from '@angular/material/form-field';

import { AppComponent } from './app.component';
import { MAPBOX_ACCESSTOKEN } from './app.config';
import { routing } from './app.routing.modules';
import { AgenciaSelecionarComponent } from './components/agencia-selecionar/agencia-selecionar.component';
import { AlterarAssinaturaComponent } from './components/alterar-assinatura/alterar-assinatura.component';
import { AlterarsenhaComponent } from './components/alterarsenha/alterarsenha.component';
import { CambioComponent } from './components/cambio/cambio.component';
import { FinanciamentoBoletosComponent } from './components/financiamentos/financiamento-boletos/financiamento-boletos.component';
import { FinanciamentoFormComponent } from './components/financiamentos/financiamento-form/financiamento-form.component';
import { FinanciamentosComponent } from './components/financiamentos/financiamentos.component';
import { HotelDetailsComponent } from './components/hotel-details/hotel-details.component';
import { LaminasComponent } from './components/laminas/laminas.component';
import { LoaderComponent } from './components/loader/loader.component';
import { LogComponent } from './components/log/log.component';
import { ModalComponent } from './components/modal/modal.component';
import AereoCardComponent from './components/orcamento/aereo-card/aereo-card.component';
import { HotelCardComponent } from './components/orcamento/hotel-card/hotel-card.component';
import { IngressosCardComponent } from './components/orcamento/ingressos-card/ingressos-card.component';
import { PacoteCardComponent } from './components/orcamento/pacote-card/pacote-card.component';
import { ServicoCardComponent } from './components/orcamento/servico-card/servico-card.component';
import { ProdutoofflineComponent } from './components/produtooffline/produtooffline.component';
import { QuartosComponent } from './components/quartos/quartos.component';
import { RecuperarSenhaComponent } from './components/recuperar-senha/recuperar-senha.component';
import { ReservaPagamentosComponent } from './components/reserva-pagamentos/reserva-pagamentos.component';
import { ReservaTermometroComponent } from './components/reserva-termometro/reserva-termometro.component';
import { AereoCancelaComponent } from './components/reserva/aereo-cancela/aereo-cancela.component';
import { AereoEmiteComponent } from './components/reserva/aereo-emite/aereo-emite.component';
import { AereoReservaComponent } from './components/reserva/aereo-reserva/aereo-reserva.component';
import { BetoCancelaComponent } from './components/reserva/beto-cancela/beto-cancela.component';
import { BetoReservaComponent } from './components/reserva/beto-reserva/beto-reserva.component';
import { CancelaPacoteComponent } from './components/reserva/cancela-pacote/cancela-pacote.component';
import { CarroCancelaComponent } from './components/reserva/carro-cancela/carro-cancela.component';
import { CarroReservaComponent } from './components/reserva/carro-reserva/carro-reserva.component';
import { ComprovanteCartaoComponent } from './components/reserva/comprovante-cartao/comprovante-cartao.component';
import { EstornoPagamentoComponent } from './components/reserva/estorno-pagamento/estorno-pagamento.component';
import { HotelReservaComponent } from './components/reserva/hotel-reserva/hotel-reserva.component';
import { ReservaPacoteComponent } from './components/reserva/reserva-pacote/reserva-pacote.component';
import { SelecionarConsultorComponent } from './components/reserva/selecionar-consultor/selecionar-consultor.component';
import { ServicoCancelaComponent } from './components/reserva/servico-cancela/servico-cancela.component';
import { ServicoReservaComponent } from './components/reserva/servico-reserva/servico-reserva.component';
import { SlipComponent } from './components/slip/slip.component';
import { MaterialConfigModule } from './core/date-adapter/material-config.module';
import { Agencia, Busca, BuscaAereoRQ } from './model';
import { OrcamentodownloadComponent } from './orcamentodownload/orcamentodownload.component';
import {
  AereoService,
  AeroportoService,
  AgenciaService,
  AuthInterceptor,
  CambioService,
  CidadeService,
  EmpresaService,
  FinanciamentoService,
  FormaPagamentoService,
  HotelService,
  LoaderInterceptor, LoaderService,
  LoginService,
  LogService,
  MapaService,
  PaisService,
  ParametroService,
  PerfilMarkupService,
  ProfissaoService,
  ReservaService,
  SeguroService,
  ServicoService,
  UsuarioService,
  Util,
  VoucherService,
  WsService,
  CircuitoService
} from './services';
import { TiposDeProdutosService } from './services/cadastro/tipos-de-produtos.service';
import { ProdutoOfflineFornecedorService } from './services/gerenciamento/produtoofflinefornecedor.service';
import { LaminasService } from './services/laminas.service';
import { BetoCarreroService } from './services/turismo/beto-carrero.service';
import { CarroService } from './services/turismo/carro.service';
import { ProdutoOfflineService } from './services/turismo/produtooffline.service';
import { ProdutoOfflineItemService } from './services/turismo/produtoofflineitem.service';
import { BuscaComponent } from './shared/busca/busca.component';
import { EstrelasComponent } from './shared/estrelas/estrelas.component';
import { FooterComponent } from './shared/footer/footer.component';
import { HeaderComponent } from './shared/header/header.component';
import { InputComponent } from './shared/input/input.component';
import { LoadingSmallComponent } from './shared/loading-small/loading-small.component';
import { NavbarComponent } from './shared/navbar/navbar.component';
import { PaginacaoComponent } from './shared/paginacao/paginacao.component';
import { TrechoSimbolComponent } from './shared/trecho-simbol/trecho-simbol.component';
import { TypeaheadComponent } from './shared/typeahead/typeahead.component';
import { ViewLoadingComponent } from './shared/view-loading/view-loading.component';
import { AreaTesteComponent } from './views/area-teste/area-teste.component';
import { AutenticacaoComponent } from './views/autenticacao/autenticacao.component';
import { HomeComponent } from './views/home/home.component';
import { BetoCarreroPreOrcamentoComponent } from './views/lista-beto-carrero/beto-carrero-pre-orcamento/beto-carrero-pre-orcamento.component';
import { BetoCarreroComponent } from './views/lista-beto-carrero/beto-carrero/beto-carrero.component';
import { ListaBetoCarreroComponent } from './views/lista-beto-carrero/lista-beto-carrero.component';
import { ListaPacotesComponent } from './views/lista-pacotes/lista-pacotes.component';
import { PacoteHotelComponent } from './views/lista-pacotes/pacote-hotel/pacote-hotel.component';
import { PacoteServicoComponent } from './views/lista-pacotes/pacote-servico/pacote-servico.component';
import { PacotesComponent } from './views/lista-pacotes/pacotes/pacotes.component';
import { PreOrcamentoComponent } from './views/lista-pacotes/pre-orcamento/pre-orcamento.component';
import { AereoComponent } from './views/listagem/lista-aereo/aereo/aereo.component';
import { BloqueioComponent } from './views/listagem/lista-aereo/bloqueio/bloqueio.component';
import { ListaAereoComponent } from './views/listagem/lista-aereo/lista-aereo.component';
import { CarroComponent } from './views/listagem/lista-carro/carro/carro.component';
import { ListaCarroComponent } from './views/listagem/lista-carro/lista-carro.component';
import { HotelDetalhesComponent } from './views/listagem/lista-hotel/hotel-detalhes/hotel-detalhes.component';
import { HotelMapaComponent } from './views/listagem/lista-hotel/hotel-mapa/hotel-mapa.component';
import { HotelQuartosComponent } from './views/listagem/lista-hotel/hotel-quartos/hotel-quartos.component';
import { HotelComponent } from './views/listagem/lista-hotel/hotel/hotel.component';
import { ListaHotelComponent } from './views/listagem/lista-hotel/lista-hotel.component';
import { ListaServicoComponent } from './views/listagem/lista-servico/lista-servico.component';
import { ServicoDetalhesComponent } from './views/listagem/lista-servico/servico-detalhes/servico-detalhes.component';
import { ServicoTarifagemModalComponent } from './views/listagem/lista-servico/servico-tarifagem-modal/servico-tarifagem-modal.component';
import { ServicoComponent } from './views/listagem/lista-servico/servico/servico.component';
import { ListagemComponent } from './views/listagem/listagem.component';
import { OrcamentoBetoCardComponent } from './views/listagem/orcamento/orcamento-beto-card/orcamento-beto-card.component';
import { OrcamentoCarroCardComponent } from './views/listagem/orcamento/orcamento-carro-card/orcamento-carro-card.component';
import { OrcamentoHotelCardComponent } from './views/listagem/orcamento/orcamento-hotel-card/orcamento-hotel-card.component';
import { OrcamentoPacoteCardComponent } from './views/listagem/orcamento/orcamento-pacote-card/orcamento-pacote-card.component';
import { OrcamentoServicoCardComponent } from './views/listagem/orcamento/orcamento-servico-card/orcamento-servico-card.component';
import { RebuscaComponent } from './views/listagem/rebusca/rebusca.component';
import { RevisaOrcamentoComponent } from './views/listagem/revisa-orcamento/revisa-orcamento.component';
import { MeusOrcamentosComponent } from './views/meus-orcamentos/meus-orcamentos.component';
import { OrcamentoComponent } from './views/orcamento/orcamento.component';
import { VoucherComponent } from './voucher/voucher.component';
import { ListaFornecedoresComponent } from './views/listagem/lista-hotel/lista-fornecedores/lista-fornecedores.component';
import { CircuitoComponent } from './views/listagem/lista-circuito/circuito/circuito.component';
import { ListaCircuitoComponent } from './views/listagem/lista-circuito/lista-circuito.component';
import { CircuitoDetalhesComponent } from './components/circuito-detalhes/circuito-detalhes.component';
import { CircuitoPreOrcamentoComponent } from './views/listagem/lista-circuito/circuito-pre-orcamento/circuito-pre-orcamento.component';
import { CustomNumberPickerComponent } from './views/listagem/lista-circuito/custom-number-picker/custom-number-picker.component';
import { CircuitoReservaComponent } from './components/reserva/circuito-reserva/circuito-reserva.component';
import { CircuitoCancelaComponent } from './components/reserva/circuito-cancela/circuito-cancela.component';

registerLocaleData(localePt);
TagInputModule.withDefaults({
  tagInput: {
    placeholder: 'Adicionar',
  },
  dropdown: {
    displayBy: 'my-display-value',
  },
});
@NgModule({
  declarations: [
    AppComponent,
    OrcamentodownloadComponent,
    NavbarComponent,
    FooterComponent,
    HomeComponent,
    HeaderComponent,
    PacotesComponent,
    HotelComponent,
    AlterarsenhaComponent,
    ListaServicoComponent,
    ServicoComponent,
    RevisaOrcamentoComponent,
    OrcamentoHotelCardComponent,
    OrcamentoServicoCardComponent,
    MeusOrcamentosComponent,
    PacoteHotelComponent,
    OrcamentoComponent,
    ListaHotelComponent,
    ListaAereoComponent,
    AgenciaSelecionarComponent,
    AereoComponent,
    AreaTesteComponent,
    TrechoSimbolComponent,
    AereoCardComponent,
    TypeaheadComponent,
    BuscaComponent,
    PaginacaoComponent,
    ListagemComponent,
    HotelReservaComponent,
    SelecionarConsultorComponent,
    InputComponent,
    AereoCancelaComponent,
    AereoEmiteComponent,
    AereoReservaComponent,
    HotelReservaComponent,
    ServicoReservaComponent,
    ServicoCancelaComponent,
    EstornoPagamentoComponent,
    ComprovanteCartaoComponent,
    ReservaPagamentosComponent,
    LoadingSmallComponent,
    ViewLoadingComponent,
    CambioComponent,
    RebuscaComponent,
    HotelDetailsComponent,
    RecuperarSenhaComponent,
    ListaPacotesComponent,
    OrcamentoPacoteCardComponent,
    EstrelasComponent,
    VoucherComponent,
    LoaderComponent,
    HotelDetalhesComponent,
    PacoteServicoComponent,
    PreOrcamentoComponent,
    HotelQuartosComponent,
    ServicoDetalhesComponent,
    ReservaPacoteComponent,
    CancelaPacoteComponent,
    LaminasComponent,
    LogComponent,
    BloqueioComponent,
    ListaCarroComponent,
    CarroComponent,
    OrcamentoCarroCardComponent,
    CarroReservaComponent,
    CarroCancelaComponent,
    ListaBetoCarreroComponent,
    BetoCarreroComponent,
    BetoCarreroPreOrcamentoComponent,
    BetoReservaComponent,
    BetoCancelaComponent,
    OrcamentoBetoCardComponent,
    ProdutoofflineComponent,
    ServicoTarifagemModalComponent,
    AutenticacaoComponent,
    FinanciamentosComponent,
    FinanciamentoFormComponent,
    FinanciamentoBoletosComponent,
    ReservaTermometroComponent,
    SlipComponent,
    HotelMapaComponent,
    QuartosComponent,
    CircuitoComponent,
    ListaCircuitoComponent,
    CircuitoDetalhesComponent,
    CircuitoPreOrcamentoComponent,
    CustomNumberPickerComponent,
    CircuitoReservaComponent,
    AlterarAssinaturaComponent,
    HotelCardComponent,
    ServicoCardComponent,
    PacoteCardComponent,
    IngressosCardComponent,
    CircuitoCancelaComponent,
    ModalComponent,
    ListaFornecedoresComponent,
  ],
  imports: [
    BrowserModule,
    routing,
    FormsModule,
    NgxSliderModule,
    NgbAccordionModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    NgxMapboxGLModule.withConfig({
      accessToken: MAPBOX_ACCESSTOKEN
    }),
    NgxExtendedPdfViewerModule,
    TagInputModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    CarouselModule,
    NgbModule,
    NgbAccordionModule,
    ToastModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatInputModule,
    NgxCurrencyDirective,
    MaterialConfigModule,
    MatStepperModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    NgxMaskDirective,
    NgxMaskPipe,
    MatCardModule,
    MatExpansionModule
  ],
  providers: [
    LoginService,
    ParametroService,
    LoaderService,
    CidadeService,
    AgenciaService,
    AeroportoService,
    ReservaService,
    AereoService,
    HotelService,
    ServicoService,
    SeguroService,
    LogService,
    UsuarioService,
    VoucherService,
    EmpresaService,
    PerfilMarkupService,
    WsService,
    FormaPagamentoService,
    PaisService,
    ProfissaoService,
    CambioService,
    LaminasService,
    CarroService,
    BetoCarreroService,
    ProdutoOfflineService,
    ProdutoOfflineItemService,
    ProdutoOfflineFornecedorService,
    TiposDeProdutosService,
    Agencia,
    Busca,
    BuscaAereoRQ,
    MessageService,
    FinanciamentoService,
    MapaService,
    Util,
    CircuitoService,
    { provide: APP_BASE_HREF, useValue: "/" },
    { provide: LOCALE_ID, useValue: 'pt-BR' },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true },
    provideNgxMask(),
    provideHttpClient(withInterceptorsFromDi())
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

